import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setWaNumber } from "@/lib/api";

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const reload = useCallback(() => api.get("/settings").then((r) => { setWaNumber(r.data.whatsapp_number); setSettings(r.data); }).catch(() => setSettings({})), []);
  useEffect(() => { reload(); }, [reload]);
  if (!settings) return <div className="min-h-screen bg-[#F5F0E8]" />;
  return <SettingsContext.Provider value={{ ...settings, reload }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
